{
	"title": "附加檔案",
	"listColumn1": "檔案名稱",
	"listColumn2": "檔案大小",
	"listColumn3": "分類",
	"listColumn4": "說明",
	"listColumn5": "更新日期",
	"listColumn6": "修改者",
	"listColumn7": "刪除",
	"pic": "圖檔",
	"audio": "聲音",
	"video": "影片",
	"doc": "文件",
	"uploadFile": "上傳",
	"emptyList": "尚無附加檔案",
	"lackFile": "(檔案遺失)"
}